import { render } from "./intro.vue?vue&type=template&id=71e70b65&scoped=true"
import script from "./intro.vue?vue&type=script&lang=js"
export * from "./intro.vue?vue&type=script&lang=js"

import "./intro.vue?vue&type=style&index=0&id=71e70b65&lang=less&scoped=true"

import exportComponent from "/Users/ym/Desktop/tianmuli/tml-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e70b65"]])

export default __exports__